import { PROCESS_GROUPS } from './process-material-config'
import { isPartProcess } from './process-normalization'

/**
 * Display label for a manufacturing process, keyed by the `PartProcess` enum
 * token. Built from the generated catalog's `PROCESS_GROUPS` (the single source
 * of process labels in the app) so labels never drift from the catalog.
 */
const LABEL_BY_TOKEN: Readonly<Record<string, string>> = Object.fromEntries(
  [...PROCESS_GROUPS.instantManual, ...PROCESS_GROUPS.manualQuote].map((entry) => [
    entry.id,
    entry.label,
  ]),
)

/**
 * Human-readable label for a stored or DFM-derived `process` value shown in the
 * UI. A raw `PartProcess` enum token (e.g. `cnc_machining`,
 * `sheet_metal_fabrication`) is mapped to its catalog label (`CNC machining`,
 * `Sheet metal fabrication`). Any other string — legacy free-text such as
 * `CNC Milling` or `5-axis CNC`, which is already human-readable and often more
 * specific — is returned unchanged (we don't flatten a descriptive label down to
 * the generic canonical one).
 */
export function formatProcessLabel(raw: string): string {
  return isPartProcess(raw) ? (LABEL_BY_TOKEN[raw] ?? raw) : raw
}
